import { useNavigate } from 'react-router-dom';
import { useAdminOrderEvents } from '@/domains/dashboard-management/hooks/useAdminOrders';
import { showToast } from '@/shared/utils/showToast';

// Off for now: a reported transfer still reloads the orders at once, without the toast
export const TRANSFER_TOAST_ENABLED = false;

/** On every admin page: a reported bank transfer reloads the orders at once and, with
 *  TRANSFER_TOAST_ENABLED, shows a toast until the admin opens the order or closes it. Renders
 *  nothing. */
const AdminOrderAlerts = () => {
  const navigate = useNavigate();

  useAdminOrderEvents((event) => {
    if (!TRANSFER_TOAST_ENABLED) return;
    showToast({
      type: 'info',
      title: 'Transfer perlu dicek',
      message: `Pembeli pesanan ${event.order_number} sudah transfer. Cek mutasi rekening, lalu konfirmasi pembayaran.`,
      actions: [
        {
          label: 'Lihat Transaksi',
          onClick: () =>
            navigate(`/dashboard/history-detail?id=${event.order_id}`, {
              state: { code: event.order_number },
            }),
        },
      ],
    });
  });

  return null;
};

export default AdminOrderAlerts;
